import { Controller } from "@hotwired/stimulus"

// "Mostrar contraseña" next to a password field: flips the input type and the
// button label. Purely client-side; the form submits the same either way.
export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    const showing = this.inputTarget.type === "text"
    this.inputTarget.type = showing ? "password" : "text"
    this.buttonTarget.textContent = showing ? "Mostrar contraseña" : "Ocultar contraseña"
    this.buttonTarget.setAttribute("aria-pressed", String(!showing))
  }
}
